import React from "react";

/* Sidebar — primary navigation. */

const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: "Home" },
  { id: "opportunities", label: "Opportunities", icon: "Inbox" },
  { id: "conversations", label: "Responses", icon: "Comment" },
  { id: "scans", label: "Scans", icon: "Scan" },
  { id: "profile", label: "Profile", icon: "User" },
  { id: "pricing", label: "Plans", icon: "DollarSign" },
  { id: "settings", label: "Settings", icon: "Settings" },
];

function Sidebar({ screen, onNavigate, profile, userEmail, onLogout }) {
  const { user } = window.useCurrentUser();
  const [loggingOut, setLoggingOut] = React.useState(false);
  const displayEmail = user?.email || userEmail || "sam@groupcast.app";
  const displayName = user?.name?.trim()
    || (userEmail ? userEmail.split("@")[0].replace(/[._-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "Sam Reyes");
  const initials = displayName.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  const handleLogout = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await onLogout?.();
    } catch (e) {
      setLoggingOut(false);
    }
  };
  const renderItem = (item) => {
    const IconCmp = window.I[item.icon];
    return (
      <button
        key={item.id}
        className="nav-item"
        aria-current={screen === item.id ? "page" : undefined}
        onClick={() => onNavigate(item.id)}
      >
        <IconCmp className="nav-icon" />
        <span>{item.label}</span>
      </button>
    );
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <img
          src="/assets/icon.png"
          alt="Community Ninja"
          className="logo-mark"
          style={{ background: "none" }}
        />
        <div>
          <div className="logo-name">Community Ninja</div>
          <div style={{ fontSize: 11, color: "var(--text-tertiary)", marginTop: 1 }}>Signals Engine</div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {NAV_ITEMS.map(renderItem)}
      </div>
      <div className="sidebar-footer">
        <div className="user-card" title={`${displayName} — ${displayEmail}`}>
          <div className="avatar">{initials}</div>
          <div className="user-meta">
            <div className="user-name">{displayName}</div>
            <div className="user-email">{displayEmail}</div>
          </div>
          <button
            type="button"
            className="user-logout"
            onClick={handleLogout}
            disabled={loggingOut}
            aria-label={loggingOut ? "Logging out" : "Log out"}
            title={loggingOut ? "Logging out" : "Log out"}
          >
            {loggingOut ? <window.I.Refresh size={14} style={{ animation: "spin 900ms linear infinite" }} /> : <window.I.LogOut size={14} />}
          </button>
        </div>
      </div>
    </aside>
  );
}

window.Sidebar = Sidebar;
